import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {ResourceService} from "../../services/resource.service";
import {Resource} from "../../models/resource";

@Injectable()
export class ResourceResolve implements Resolve<Resource> {
    constructor(private resourceService: ResourceService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Resource> {
        return this.resourceService.getById(route.params.id);
    }
}
